// Story 204 (P9): the constants of the exposed Java enums a column filters by translated label (RN1.9). They are
// stable enums of Sun, listed here because Jupiter carries no copy of Sun's catalogue any more; a constant Sun adds
// shows up translated by its code as soon as the row arrives, it only misses from the filter until it is listed here.
export const ENUM_CODES = {
  DeviceStatusEnum: ['ERROR', 'IDLE', 'NON_OPERATIVE', 'OFF', 'STOPPED', 'WORKING'],
  FabricationOrderGlobalStatusEnum: ['CLOSED', 'LAUNCHED', 'PENDING', 'PLANNED'],
  PurchaseOrderStatusEnum: ['FINISHED', 'PARTIAL', 'PENDING'],
  QualityIncidenceActionResultEnum: ['NO_OK', 'OK', 'PENDING'],
  QualityIncidenceActionStatusEnum: ['MADE', 'PARTIAL_MADE', 'PENDING'],
  QualityIncidenceActionTypeEnum: ['CONTAINMENT', 'CORRECTIVE'],
  QualityIncidenceStatusEnum: ['ANALYSIS', 'CLOSED', 'DRAFT', 'PENDING', 'PENDING_ACTION'],
  RawMaterialStatus: ['AVAILABLE', 'AVAILABLE_IN_MACHINE', 'INCIDENCE', 'PENDING', 'PROCESSED', 'REJECTED'],
  // P19
  ChangeLogType: ['CREATE', 'DELETE', 'OTHER', 'UPDATE'],
  ClusterSyncOperationResultEnum: ['ERROR', 'SUCCESS', 'WARNING'],
  ClusterSyncOperationTypeEnum: ['CREATE', 'DELETE', 'RESYNC', 'UPDATE'],
  NodeTypeEnum: ['JOB', 'WORKFLOW'],
  PurchaseOrderTheoreticalReceptionStatusEnum: ['FINISHED', 'PENDING', 'QUALITY', 'REAL', 'THEORETICAL'],
  PurchaseOrderTypeEnum: ['AUTOMATIC', 'MANUAL'],
  QualityIncidencePriorityEnum: ['CRITICAL', 'HIGH', 'LOW', 'MEDIUM'],
  QualityIncidenceResourceTypeEnum: ['PART', 'RAW_MATERIAL'],
  RuleResourceEnum: ['DEVICE', 'FIXTURE', 'PART', 'RAW_MATERIAL', 'TOOL']
}

/** The codes of an exposed enum, in the order the filter lists them. */
export const enumCodesOf = (domain) => ENUM_CODES[domain] || []
